import { IGlobalState } from '../../../Root/store/appReducer'

export const getSignUpLastUpdate = (state: IGlobalState) => state.signUp.lastUpdate
